import React, { ErrorInfo } from 'react';

import { ApplicationErrorPage } from '@topconagriculture/react-components';
import { TENANTS } from '@topconagriculture/theme';

import { config } from '../config';

export class ErrorBoundary extends React.Component {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // tslint:disable-next-line:no-console
    console.error('------ START TAP ERROR LOG ------');
    // tslint:disable-next-line:no-console
    console.error('error: ', error);
    // tslint:disable-next-line:no-console
    console.error('errorInfo: ', errorInfo);
    // tslint:disable-next-line:no-console
    console.error('------ END TAP ERROR LOG ------');
  }

  render() {
    if ((this.state as any).hasError) {
      // You can render any custom fallback UI
      return (
        <ApplicationErrorPage tenantName={config.TENANT_NAME as TENANTS} imagesBaseUrl={config.RESOURCES_BASE_URL} />
      );
    }

    return this.props.children;
  }
}
